import React, { useContext, useEffect, useRef, useState } from "react";
import {
  getHistoryByDateRange,
  getMostSkillUsedandTop10Skills,
} from "../../../services/graphsService";
import loaderContext from "../../../../../../context/loader/loaderContext";
import { DaysFilter } from "../../../../../../constants/enums";
import SkillMapWrapper from "../mapDisplay/mapWrapper";
import TotalUsers from "../totalUsers";
import TotalChats from "../totalChats";
import TotalSessions from "../totalSessions";
import OverviewDashboard from "../overviewDashboard";
import TotalResourceCost from "../totalResourceCost";
import { usePermissions } from "../../../../../common/customHooks/usePermissions";
import TopUsersChart from "../top10users";
import SkillPopularityChart from "../mostpopularskill";

const DasboardCharts = () => {
  const { updateLoaderStatus } = useContext(loaderContext);
  const [range, setRange] = useState("Last 30 Days");
  const [skills, setSkills] = useState([]);
  const [chatHistoryData, setChatHistoryData] = useState(null);
  const [otherChatHistoryData, setOtherChatHistoryData] = useState(null);
  const [selectedSkill, setSelectedSkill] = useState("");

  const { allSkills } = usePermissions(0);
  const skillref = useRef(null);
  useEffect(() => {
    if (allSkills.length > 0) setSkills(allSkills);
  }, [allSkills]);

  useEffect(() => {
    if (skillref.current && skills?.length > 0) {
      skillref.current.value = skills[0].Id;
      setSelectedSkill(skillref.current.value);
      handleFilterRecords(skillref.current.value, range);
    }
  }, [skills]);

  const handleFilterRecords = async (selectedValue, range) => {
    if (selectedValue === "" || selectedValue === "-1") {
      return;
    }
    try {
      updateLoaderStatus(true);
      const data = await getHistoryByDateRange(range);
      const otherData = await getMostSkillUsedandTop10Skills(
        parseInt(selectedValue),
        range
      );
      if (data) {
        const filteredSkills = data
          .map((day) => {
            const matchedSkills = day.skills.filter(
              (skill) => skill.skillId === parseInt(selectedValue)
            );
            return {
              date: day.date,
              skills: matchedSkills,
            };
          })
          .filter((day) => day.skills.length > 0);
        if (filteredSkills !== undefined && filteredSkills !== null)
          setChatHistoryData(filteredSkills);
        else {
          setChatHistoryData([]);
        }
      } else {
        setChatHistoryData([]);
      }
      if (otherData) {
        const mostUsedSkillsWithName = otherData.most_used_skills.map(
          (item) => {
            const matchedSkill = skills.find((s) => s.Id === item.skillId);
            return {
              ...item,
              SkillName: matchedSkill ? matchedSkill.Name : "Unknown Skill",
            };
          }
        );

        const topUsers = otherData.top_users_for_skill.map(
          ({ count, userEmail, user_Id }) => ({
            count,
            userEmail: userEmail
              ? userEmail
              : user_Id
              ? user_Id //user_Id.slice(0, 13)
              : "",
          })
        );

        const finalResult = {
          ...otherData,
          most_used_skills: mostUsedSkillsWithName,
          top_users_for_skill: topUsers,
        };
        if (finalResult !== undefined && finalResult !== null)
          setOtherChatHistoryData(finalResult);
        else {
          setOtherChatHistoryData([]);
        }
      } else {
        setOtherChatHistoryData([]);
      }
      updateLoaderStatus(false);
    } catch (error) {
      updateLoaderStatus(false);
    }
  };

  return (
    <div>
      <div className="chart-div-display">
        <div>
          <select
            data-title="selected skill"
            className={"prompt-skill prompt-hoverskill skill-select-charts"}
            onChange={(e) => {
              setSelectedSkill(e.target.value);
              if (e.target.value === "-1") {
                setChatHistoryData(null);
              } else {
                handleFilterRecords(e.target.value, range);
              }
              e.preventDefault();
            }}
            ref={skillref}
          >
            <option value="-1">Select Skill</option>
            {skills?.map((item) => (
              <option key={item.Id} value={item.Id}>
                {item.Name}
              </option>
            ))}
          </select>
        </div>
        <div>
          <button
            className={
              range === DaysFilter.Days7
                ? "chart-button-display chart-left-border-radius chart-active-button"
                : "chart-button-display chart-left-border-radius"
            }
            onClick={() => {
              setRange(DaysFilter.Days7);
              if (selectedSkill !== "" && selectedSkill !== "-1") {
                handleFilterRecords(selectedSkill, DaysFilter.Days7);
              }
            }}
          >
            7 Days
          </button>
          <button
            className={
              range === DaysFilter.Days30
                ? "chart-button-display chart-active-button"
                : "chart-button-display"
            }
            onClick={() => {
              setRange(DaysFilter.Days30);
              if (selectedSkill !== "" && selectedSkill !== "-1") {
                handleFilterRecords(selectedSkill, DaysFilter.Days30);
              }
            }}
          >
            1 Month
          </button>
          <button
            className={
              range === DaysFilter.Days60
                ? "chart-button-display chart-active-button"
                : "chart-button-display"
            }
            onClick={() => {
              setRange(DaysFilter.Days60);
              if (selectedSkill !== "" && selectedSkill !== "-1") {
                handleFilterRecords(selectedSkill, DaysFilter.Days60);
              }
            }}
          >
            2 Months
          </button>
          <button
            className={
              range === DaysFilter.Days90
                ? "chart-button-display chart-right-border-radius chart-active-button"
                : "chart-button-display chart-right-border-radius"
            }
            onClick={() => {
              setRange(DaysFilter.Days90);
              if (selectedSkill !== "" && selectedSkill !== "-1") {
                handleFilterRecords(selectedSkill, DaysFilter.Days90);
              }
            }}
          >
            3 Months
          </button>
        </div>
      </div>
      {/* {chatHistoryData?.length > 0 ? ( */}
      <div>
        <OverviewDashboard
          chartsData={chatHistoryData}
          periodSelected={range}
        ></OverviewDashboard>
        <div className="chart-row-view">
          <TotalUsers
            selectedSkill={selectedSkill}
            skills={skills}
            chartsData={chatHistoryData}
          ></TotalUsers>
          <TotalChats
            selectedSkill={selectedSkill}
            skills={skills}
            chartsData={chatHistoryData}
          ></TotalChats>
        </div>
        <div className="chart-row-view">
          <TotalSessions
            selectedSkill={selectedSkill}
            skills={skills}
            chartsData={chatHistoryData}
          ></TotalSessions>
          <TotalResourceCost
            selectedSkill={selectedSkill}
            selectedRange={range}
            skills={skills}
          ></TotalResourceCost>
        </div>
        <div className="chart-row-view">
          <TopUsersChart
            selectedSkill={selectedSkill}
            skills={skills}
            chartsData={otherChatHistoryData}
          ></TopUsersChart>
          <SkillPopularityChart
            selectedSkill={selectedSkill}
            selectedRange={range}
            skills={skills}
            chartsData={otherChatHistoryData}
          ></SkillPopularityChart>
        </div>
        <div>
          <SkillMapWrapper chartsData={chatHistoryData}></SkillMapWrapper>
        </div>
      </div>
      {/* ) : chatHistoryData === null ? (
        <div className="filter-display-boarder">
          Select Filters to View Records
        </div>
      ) : (
        <div className="filter-display-boarder">No Records Found</div>
      )} */}
    </div>
  );
};

export default DasboardCharts;
